import { render, staticRenderFns } from "./tj.vue?vue&type=template&id=8c018c98&scoped=true"
import script from "./tj.vue?vue&type=script&lang=js"
export * from "./tj.vue?vue&type=script&lang=js"
import style0 from "./tj.vue?vue&type=style&index=0&id=8c018c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c018c98",
  null
  
)

export default component.exports